<script lang="ts">
    import type {ComponentSize, ButtonStyle} from '../types';

    export let buttonStyle: ButtonStyle = 'default';
    export let buttonSize: ComponentSize = 'md';
    export let isBlock = false;
    export let isDisabled = false;
    export let title = '';
    export let additionalClasses = '';
    export let id: string = null;

    let buttonClasses: string;
    $: buttonClasses = `btn btn-${buttonStyle} btn-${buttonSize} ${isBlock ? 'btn-block' : ''}`;

</script>

<template>
    <button type="button"
            id={id}
            class="kp-button {buttonClasses} {additionalClasses}"
            {title}
            disabled={isDisabled}
            on:click
            on:focus
            on:blur
            on:contextmenu
            on:dblclick
            on:focusin
            on:focusout
            on:keydown
            on:keyup
            on:mouseenter
            on:mouseleave
            on:mousemove
            on:mouseout
            on:mouseover
            on:mouseup
            on:toggle
            on:touchcancel
            on:touchend
            on:touchmove
            on:touchstart>
        <slot></slot>
    </button>
</template>
